import { Inject, Injectable, NgModule } from '@angular/core';
import { Http, Headers, RequestMethod, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/debounceTime';
import { SettingsStorageService } from './settings-storage.service';
/**
 * The HTTPClient will use the JWTToken and Host/Site set in the SettingsStorageService to connect dotCMS REST Endpoints
 *
 */
var HttpClient = (function () {
    function HttpClient(http, settingsStorageService) {
        var _this = this;
        this.http = http;
        this.settingsStorageService = settingsStorageService;
        // this.http = http;
        // this.settingsService=settingsService;
        this.progress$ = Observable.create(function (observer) {
            _this.progressObserver = observer;
        }).share();
    }
    /**
     * Will append JWT Header to passed in Headers
     * @param headers
     */
    HttpClient.prototype.createAuthorizationHeader = function (headers) {
        if (this.settingsStorageService.getSettings() != null && this.settingsStorageService.getSettings().jwt != null
            && this.settingsStorageService.getSettings().jwt.trim().length > 0) {
            headers.append('Authorization', 'Bearer ' + this.settingsStorageService.getSettings().jwt);
        }
    };
    /**
     * Currently uses a debouce time of 400 and distinctUntilChanged flags on a GET request.  This is intended to
     * limit unecessary requests to the dotCMS Endpoints. Will append needed dotCMS Host/Site and JWT AUth Token
     * @param path Endpoint path
     * @returns {Observable<Response>}
     */
    HttpClient.prototype.get = function (path) {
        var headers = new Headers();
        this.createAuthorizationHeader(headers);
        var site = this.settingsStorageService.getSettings().site;
        return this.http.get((site ? site : '') + path, { headers: headers })
            .debounceTime(400)
            .distinctUntilChanged();
    };
    /**
     * Currently uses a debouce time of 400 and distinctUntilChanged flags on a GET request.  This is intended to
     * limit unecessary requests to the dotCMS Endpoints. Will append needed dotCMS Host/Site and JWT AUth Token
     * @param path path Endpoint path
     * @param data Object to be PUT.  Will be converted to JSON String(JSON.stringify)
     * @returns {Observable<Response>}
     */
    HttpClient.prototype.put = function (path, data) {
        var opts = new RequestOptions();
        opts.method = RequestMethod.Put;
        opts.headers = new Headers({ 'Content-Type': 'application/json' });
        this.createAuthorizationHeader(opts.headers);
        return this.http.put(this.settingsStorageService.getSettings().site + path.toString(), JSON.stringify(data), opts)
            .debounceTime(400)
            .distinctUntilChanged();
    };
    /**
     * Currently uses a debouce time of 400 and distinctUntilChanged flags on a GET request.  This is intended to
     * limit unecessary requests to the dotCMS Endpoints. Will append needed dotCMS Host/Site and JWT AUth Token
     * @param path path Endpoint path
     * @param data Object to be POSTed.  Will be converted to JSON String(JSON.stringify)
     * @returns {Observable<Response>}
     */
    HttpClient.prototype.post = function (path, data) {
        var opts = new RequestOptions();
        opts.method = RequestMethod.Post;
        opts.headers = new Headers({ 'Content-Type': 'application/json' });
        this.createAuthorizationHeader(opts.headers);
        return this.http.post(this.settingsStorageService.getSettings().site + path, JSON.stringify(data), opts);
    };
    /**
     * Intended to simply saving FileAssets to dotCMS. Currently uses a debouce time of 400 and distinctUntilChanged flags on a GET request
     * This is intended to
     * limit unecessary requests to the dotCMS Endpoints. Will append needed dotCMS Host/Site and JWT AUth Token
     * @param path path Endpoint path
     * @param file Binary file to save
     * @param jsonData Object to be POSTed.  Will be converted to JSON String(JSON.stringify)
     * @returns {any}
     */
    HttpClient.prototype.filePut = function (path, file, data) {
        var _this = this;
        return Observable.create(function (observer) {
            var formData = new FormData(), xhr = new XMLHttpRequest();
            formData.append('json', JSON.stringify(data));
            formData.append('fileAsset', file);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        observer.next(JSON.parse(xhr.response));
                        observer.complete();
                    }
                    else {
                        observer.error(xhr.response);
                    }
                }
            };
            xhr.upload.onprogress = function (event) {
                _this.progress = Math.round(event.loaded / event.total * 100);
                _this.progressObserver.next(_this.progress);
            };
            var site = _this.settingsStorageService.getSettings().site;
            xhr.open('PUT', (site ? site : '') + path.toString(), true);
            if (_this.settingsStorageService.getSettings() != null && _this.settingsStorageService.getSettings().jwt != null
                && _this.settingsStorageService.getSettings().jwt.trim().length > 0) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + _this.settingsStorageService.getSettings().jwt);
            }
            console.log('FormData is ' + formData);
            xhr.send(formData);
        });
    };
    return HttpClient;
}());
export { HttpClient };
HttpClient.decorators = [
    { type: Injectable },
    { type: Inject, args: ['http',] },
    { type: Inject, args: ['settingsStorageService',] },
];
/** @nocollapse */
HttpClient.ctorParameters = function () { return [
    { type: Http, },
    { type: SettingsStorageService, },
]; };
var DotHttpModule = (function () {
    function DotHttpModule() {
    }
    return DotHttpModule;
}());
export { DotHttpModule };
DotHttpModule.decorators = [
    { type: NgModule, args: [{
                providers: [HttpClient, SettingsStorageService]
            },] },
];
/** @nocollapse */
DotHttpModule.ctorParameters = function () { return []; };
//# sourceMappingURL=http.service.js.map